import { motion } from 'framer-motion'
import React from 'react'
import { STAGE_COLORS } from './career-path-constants'

interface TimelineDotProps {
    stage: string
    isLast: boolean
    index: number
}

const TimelineDot: React.FC<TimelineDotProps> = ({ stage, isLast, index }) => {
    const color = STAGE_COLORS[stage] || STAGE_COLORS.offboard

    return (
        <motion.div
            className="absolute left-0 top-4 z-10"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
                type: 'spring',
                stiffness: 500,
                damping: 25,
                delay: index * 0.08,
            }}
        >
            <svg width="32" height="32" viewBox="0 0 32 32" className="">
                {/* Animated pulse ring */}
                <motion.circle
                    cx="16"
                    cy="16"
                    r="12"
                    fill="none"
                    stroke={color.ring}
                    strokeWidth="2"
                    initial={{ r: 8, opacity: 0 }}
                    animate={
                        isLast
                            ? {
                                  r: [8, 14, 8],
                                  opacity: [0.6, 0, 0.6],
                              }
                            : { r: 12, opacity: 0.4 }
                    }
                    transition={
                        isLast
                            ? {
                                  duration: 2,
                                  repeat: Infinity,
                                  ease: 'easeInOut',
                              }
                            : { duration: 0.3 }
                    }
                />
                {/* Main dot */}
                <circle cx="16" cy="16" r="6" fill={color.dot} />
                {/* Inner highlight */}
                <circle cx="14.5" cy="14.5" r="2" fill="white" opacity="0.4" />
            </svg>
        </motion.div>
    )
}

export default TimelineDot
